import React from 'react';

import Col from 'react-bootstrap/Col';
import DetailList from './DetailList';
import EditorSaveCancel from '../shared/buttons/EditorSaveCancel';
import Form from 'react-bootstrap/Form';
import FormControl from '../shared/inputs/FormControl';
import Row from 'react-bootstrap/Row';
import SelectList from '../shared/inputs/SelectList';
import permissionsProvider from '../../utilities/permissionsProvider';
import PaymentDisplay from '../payment/PaymentDisplay';
import CurrencyInput from '../shared/inputs/CurrencyInput';
import PercentInput from '../shared/inputs/PercentInput';

const EditForm = ({
    cancelEdit,
    form: { formChange },
    form: { item },
    form: { reset },
    form: { setUrl },
    miscSaleId,
    submitForm,
}) => {

    const disabled = !permissionsProvider.canEdit(item.acl);
    const parentBaseUrl = '/api/miscsales/edit/';

    return (
        <div>
            <div className="item-editor">
                <Row className="justify-content-end">
                    <Col xs="auto" className="fields-required-label" />
                </Row>
                <Form.Row>
                    <Form.Group as={Col} sm={6}>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <SelectList
                                    onChange={formChange}
                                    lookupType="Designer"
                                    name="designerId"
                                    placeholder="Designer"
                                    required={true}
                                    value={item.designerId}
                                    validationError={item.designerId_error}
                                    disabled={disabled} />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <FormControl
                                    defaultValue={item.date}
                                    name="date"
                                    onChange={formChange}
                                    placeholder="Date of Sale"
                                    type="date"
                                    validationError={item.date_error}
                                    disabled={disabled} />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <SelectList
                                    name="paymentTerms"
                                    onChange={formChange}
                                    value={item.paymentTerms}
                                    validationError={item.paymentTerms_error}
                                    disabled={disabled}>
                                    <option value="1">No Terms</option>
                                    <option value="2">Net 10</option>
                                    <option value="3">Net 15</option>
                                    <option value="4">Net 30</option>
                                </SelectList>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} xs={6}>
                                <Form.Label className="col-form-label-sm">
                                    Commission:
                                </Form.Label>
                                <SelectList
                                    name="commissionType"
                                    onChange={formChange}
                                    placeholder="Commission Type"
                                    validationError={item.commissionType_error}
                                    value={item.commissionType}
                                    disabled={disabled}>
                                    <option value="1">None</option>
                                    <option value="2">Flat Rate</option>
                                    <option value="3">Percentage</option>
                                </SelectList>
                            </Form.Group>
                            {item.commissionType === 2 &&
                                <Form.Group as={Col} className="pt-4">
                                    <CurrencyInput
                                        name="commission"
                                        onChange={formChange}
                                        placeholder="Commission $"
                                        validationError={item.commission_error}
                                        value={item.commission}
                                        disabled={disabled}
                                    />
                                </Form.Group>
                            }
                            {item.commissionType === 3 &&
                                <Form.Group as={Col} className="pt-4 d-flex">
                                    <PercentInput
                                        name="commission"
                                        onChange={formChange}
                                        placeholder="Commission %"
                                        validationError={item.commission_error}
                                        value={item.commission}
                                        disabled={disabled}
                                    />
                                </Form.Group>
                            }
                        </Form.Row>
                    </Form.Group>
                    <Form.Group as={Col} sm={6}>
                        <DetailList
                            formChange={formChange}
                            items={item.miscSaleDetails}
                            miscSaleId={miscSaleId}
                            disabled={disabled}
                        />
                    </Form.Group>
                </Form.Row>
                <PaymentDisplay
                    parentId={item.id}
                    recordType='miscSale'
                    customerId={item.customerId}
                    disabled={disabled}
                    saveParent={(callBack) => submitForm(callBack)}
                    resetParentForm={reset}
                    setParentUrl={setUrl}
                    parentBaseUrl={parentBaseUrl}
                    showDetail={true}
                />
            </div>
            <EditorSaveCancel
                save={submitForm}
                cancel={cancelEdit}   
                acl={item.acl}
            />
        </div>
    );
}

export default EditForm;